function stretchLastGridItem() {
  const containers = document.querySelectorAll('.info-section__list');
  if (!containers.length) return;
  
  containers.forEach(container => {
    const items = container.querySelectorAll('.info-section__card');
    const expendCard = container.querySelector('.info-section__card--expend');
    
    items.forEach(item => {
      item.style.gridColumn = '';
    });
    
    const totalItems = items.length;
    
    let columns = parseInt(container.dataset.columns) || 3;
    
    if (window.innerWidth < 768) {
      columns = 2;
    }

    if (window.innerWidth < 480) {
      columns = 1;
    }

    if (expendCard) {
      const expendIndex = Array.from(items).indexOf(expendCard);
      const beforeExpend = items[expendIndex - 1];
      
      if (beforeExpend) {
        const itemsBeforeExpend = expendIndex;
        const remainder = itemsBeforeExpend % columns;
        
        if (remainder !== 0) {
          const span = columns - remainder + 1;
          beforeExpend.style.gridColumn = `span ${span}`;
        }
      }
    } else {
      const last = items[items.length - 1];
      const remainder = totalItems % columns;

      if (remainder !== 0) {
        const span = columns - remainder;
        last.style.gridColumn = `span ${span + 1}`;
      }
    }
  });
}

window.addEventListener('load', stretchLastGridItem);
window.addEventListener('resize', stretchLastGridItem);